// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3qKS_","large":"styles_large__3XqkG"};